'use strict';

import Handlebars from 'injectify/runtime';

Handlebars.registerHelper('isEqual', function (value1, value2) {

    return (value1 == value2);
});

Handlebars.registerHelper('isEqualStrict', function (value1, value2) {

    return (value1 === value2);
});

Handlebars.registerHelper('isGreater', function (value1, value2) {

    return (value1 > value2);
});

Handlebars.registerHelper('times', function (n, block) {

    let html = '';

    for (let i = 0; i < n; i++) {
        html += block.fn(i);
    }

    return html;
});

Handlebars.registerHelper('orCondTrue', function (value1, value2) {

    return (value1 || value2);
});

Handlebars.registerHelper('andCondTrue', function (value1, value2) {

    return (value1 && value2);
});

Handlebars.registerHelper('not', function (value1) {

    return !value1;
});


// WEBPACK FOOTER //
// ./shared/helper/logical.js